import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../Form';
import ItemModify from '../Form/ItemModify';

@inject('roleStore')
@observer
class RoleModify extends Component {
  render() {
    const { roleStore, params } = this.props;

    return (
      <ItemModify
      title='Role'
      slug = '/role'
      store = {roleStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly:true, editOnly:true },
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default RoleModify;



// WEBPACK FOOTER //
// ./src/components/Role/RoleModify.js